<template>
  <div :class="[
  'problem', 
  `item${loopIndex}`, 
  {problemMedia:dev},
  {item1Media:loopIndex === 1 && dev},
  {item2Media:loopIndex === 2 && dev},
  {item3Media:loopIndex === 3 && dev},
  {item4Media:loopIndex === 4 && dev},
  {item5Media:loopIndex === 5 && dev},
  {item6Media:loopIndex === 6 && dev},
  ]">

    <!-- 开始按钮 -->
    <div
      class="start"
      v-if="loopIndex < 1"
    >
      <img :src="require('@/assets/img/problem/start.png')">
      <img
        :class="['goBtn',{goBtnMedia:dev}]"
        :src="require('@/assets/img/problem/goBtn.png')"
        @click="handleStartClick"
      >
    </div>

    <!-- 第 一至五 题-->
    <div
      class="problem1_5"
      v-if="loopIndex > 0 && loopIndex < 6"
    >
      <!-- 占位 -->
      <div class="topicPoster">
        <span class="poster"></span>
      </div>
      <!-- 问题 -->
      <img
        :class="['topic',{topicMedia:dev}]"
        :src="require(`@/assets/img/problem/itemtopic${loopIndex}.png`)"
      >
      <img
        class="grain"
        :src="require(`@/assets/img/problem/grain${
            loopIndex === 3 || 
            loopIndex === 4 || 
            loopIndex === 5 ? 
            2 : 
            loopIndex
          }.png`)"
      >

      <!-- 选项 -->
      <ul :class="{ itemOpacity:itemOpacity }">
        <li
          :class="[{active:item.type}, {Media:dev}]"
          v-for="(item, index) in todos[loopIndex - 1]"
          :key="index"
          @click="itemClick(index)"
        >
          <span>{{item.text}}</span>
          <img
            v-show="!item.type"
            :src="require(`@/assets/img/problem/item${loopIndex}.png`)"
          >
          <img
            v-show="item.type"
            :src="require(`@/assets/img/problem/itemActive${loopIndex}.png`)"
          >
        </li>
      </ul>
    </div>

    <!-- 最后选择性别和职业 -->
    <div
      :class="['career', 'last', {lastMedia:dev}]"
      v-if="loopIndex === 6"
    >

      <!-- 占位 -->
      <div class="topicPoster">
        <span class="poster"></span>
      </div>
      <img
        class="topic"
        :src="require('@/assets/img/problem/lastTopic.png')"
      >
      <img
        class="grain"
        :src="require('@/assets/img/problem/grain2.png')"
      >
      <h2>角色性别</h2>
      <!-- sex -->
      <div class="sex">
        <!-- 男 -->
        <div
          class="sexM"
          @click="sexClick(1)"
        >
          <img
            v-show="!sex1"
            :src="require('@/assets/img/problem/sexM.png')"
          >
          <img
            v-show="sex1"
            :src="require('@/assets/img/problem/sexMactive.png')"
          >
        </div>
        <!-- 女 -->
        <div
          class="sexG"
          @click="sexClick(2)"
        >
          <img
            v-show="!sex2"
            :src="require('@/assets/img/problem/sexG.png')"
          >
          <img
            v-show="sex2"
            :src="require('@/assets/img/problem/sexGactive.png')"
          >
        </div>
      </div>
      <h2>当前流派</h2>
      <ul>
        <li
          v-for="(item, index) in lasts"
          :key="index"
          :class="{active:item.type}"
          @click="roleClick(index, item.id, $event)"
        >
          <span v-html="item.text"></span>
          <img
            v-show="!item.type"
            :src="require('@/assets/img/problem/last.png')"
          >
          <img
            v-show="item.type"
            :src="require('@/assets/img/problem/lastActive.png')"
          >
        </li>
      </ul>
    </div>

  </div>
</template>


<script>
import { mapActions } from "vuex";

export default {
  name: "Problem",
  props: {
    handleBtnClick: Function,
    loopIndex: Number,
    alertTypeFn: Function
  },
  data() {
    return {
      clickType: true, // item只可以点击一次
      sex1: false, // 男是否选中
      sex2: false, // 女是否选中
      sexType: false, // 性别只可以点击一次
      timeout: 0, // setTimeout
      by: 0, // 标记角色和性别都选中后再继续
      itemOpacity: false, // 选项比问题延迟1秒出现
      todos: [
        [
          {
            type: false,
            text: "二话不说施以援手"
          },
          {
            type: false,
            text: "进一步询问情况"
          },
          {
            type: false,
            text: "仔细观察他的情态动作"
          },
          {
            type: false,
            text: "有手有脚何不自行劳作？"
          }
        ],
        [
          {
            type: false,
            text: "别泄气，明天一定会出百炼的！"
          },
          {
            type: false,
            text: "这个队伍也太黑了吧，要换个队"
          },
          {
            type: false,
            text: "这不可能发生，我是自带紫光的欧皇"
          },
          {
            type: false,
            text: "无所谓，出不出看缘分"
          }
        ],
        [
          {
            type: false,
            text: "游戏BUG了，退出副本重进"
          },
          {
            type: false,
            text: "游戏BUG了，赶紧截图反馈"
          },
          {
            type: false,
            text: "旷世奇遇！我要去找唐宝牛"
          },

          {
            type: false,
            text: "灵异事件！赶紧下线"
          }
        ],
        [
          {
            type: false,
            text: "感谢雷火，一手提百炼"
          },
          {
            type: false,
            text: "快来膜拜欧皇吧同门！"
          },
          {
            type: false,
            text: "今天天气真好，找个情缘"
          },
          {
            type: false,
            text: "默默开心就好了，绝对不发百里"
          }
        ],
        [
          {
            type: false,
            text: "松鼠鲤鱼"
          },
          {
            type: false,
            text: "西湖醋鱼"
          },
          {
            type: false,
            text: "东坡肘子"
          },

          {
            type: false,
            text: "吃什么吃，先砸桌子"
          }
        ]
      ],
      lasts: [
        {
          id: 0,
          type: false,
          text: "碎<br/>梦"
        },
        {
          id: 1,
          type: false,
          text: "血<br/>河"
        },
        {
          id: 2,
          type: false,
          text: "神<br/>相"
        },
        {
          id: 4,
          type: false,
          text: "九<br/>灵"
        },
        {
          id: 6,
          type: false,
          text: "龙<br/>吟"
        }
      ],
      item3: {
        id: 3,
        type: false,
        text: "铁<br/>衣"
      },
      item5: {
        id: 5,
        type: false,
        text: "素<br/>问"
      },
      // 每题对应的答案
      result: [
        [
          // 第一题每个角色对应的分数
          [5, 5, 5, 5, 5, 20, 5], // A
          [5, 5, 5, 5, 5, 5, 20], // B
          [5, 5, 5, 5, 20, 5, 5], // C
          [5, 5, 5, 5, 5, 5, 5] // D
        ],
        [
          // 第二题
          [1, 2, 1, 3, 2, 15, 4],
          [2, 6, 4, 2, 2, 4, 4],
          [4, 1, 2, 1, 10, 2, 4],
          [1, 0, 0, 0, 0, 5, 9]
        ],
        [
          // 第三题
          [0, 3, 0, 6, 0, 0, 0],
          [0, 0, 0, 0, 0, 2, 4],
          [3, 0, 0, 0, 1, 0, 0],
          [0, 0, 3, 0, 0, 0, 0]
        ],
        [
          // 第四题
          [0, 3, 5, 0, 2, 0, 0],
          [3, 0, 0, 0, 1, 0, 5],
          [0, 0, 0, 0, 2, 2, 0],
          [1, 0, 0, 3, 0, 0, 0]
        ],
        [
          // 第五题
          [20, 25, 5, 10, 5, 5, 5],
          [5, 5, 25, 5, 20, 20, 10],
          [15, 15, 15, 25, 10, 5, 5],
          [25, 20, 20, 25, 10, 5, 15]
        ]
      ]
    };
  },
  computed: {
    dev() {
      return this.$store.state.dev;
    },
    score() {
      return this.$store.state.score;
    },
    resSex() {
      return this.$store.state.sex;
    }
  },
  mounted() {
    this.lasts.push(this.item3);
    this.lasts.push(this.item5);

    // 选项比问题延迟1秒出现
    setTimeout(() => {
      this.itemOpacity = true;
    }, 200);
  },
  methods: {
    ...mapActions(["recordingFn", "sexFn", "roleFn", "scoreFn"]),
    handleStartClick() {
      nie.config.stats.url.add(
        location.host + location.pathname + "/page2/",
        "开始"
      );
      this.handleBtnClick();
    },
    // 测试题点击
    itemClick(i) {
      if (this.clickType) {
        this.clickType = false;
        // 计分器
        this.setResult(i);
        // this.todos[this.loopIndex - 1][this.itemIndex].type = false; // 把上一个active改为false
        this.todos[this.loopIndex - 1][i].type = true; // 把点击的item改为true
        this.videoGo(); // 视频继续播放

        let op = "";
        switch (i) {
          case 0:
            op = "A";
            break;
          case 1:
            op = "B";
            break;
          case 2:
            op = "C";
            break;
          case 3:
            op = "D";
            break;
        }

        let str = `第${this.loopIndex}题_${op}`;

        nie.config.stats.url.add(
          location.host + location.pathname + "/page2/",
          str
        );
      }
    },
    setScoreGM(i) {
      let arr = this.score;
      arr[i] = 0;
      this.scoreFn(arr);
    },
    // 性别点击
    sexClick(t) {
      // 选男
      this.sexType = true;
      if (t === 1) {
        this.sex2 = false;
        this.sex1 = true;

        nie.config.stats.url.add(
          location.host + location.pathname + "/page2/",
          "角色性别：男"
        );
      }
      // 选女
      if (t === 2) {
        this.sex1 = false;
        this.sex2 = true;
        nie.config.stats.url.add(
          location.host + location.pathname + "/page2/",
          "角色性别：女"
        );
      }
      this.sexFn(t); // 修改全局男女标记
      this.handleBy(); // 判断是否继续播放视频

      // 根据选中的性别隐藏元素
      this.removeItem();
    },
    // 男没5
    // 女没3
    // 角色点击
    roleClick(i, id, e) {
      if (this.clickType && this.sexType) {
        this.clickType = false; // 禁止第二次点击
        this.lasts[i].type = true; //选中active
        this.handleBy(); // 判断是否继续播放视频

        // 根据用户选中的角色改变测试结果
        this.setScore(id);
        nie.config.stats.url.add(
          location.host + location.pathname + "/page2/",
          `流派选择：${e.srcElement.parentNode.innerText}`
        );
      } else {
        // else 弹窗
        if (!this.sexType) {
          this.alertTypeFn(true);
        }
      }
    },
    // 删除数组中的某一个元素
    removeItem() {
      // 1男没5
      // 2女没3
      this.lasts.splice(5); // 删除 3 和 5

      // 男
      if (this.resSex === 1) {
        this.lasts.push(this.item3);
      }
      // 女
      if (this.resSex === 2) {
        this.lasts.push(this.item5);
      }
    },
    // 判断视频是否可以继续播放
    handleBy() {
      this.by = 0;
      if (this.sex1 || this.sex2) {
        this.by++;
      }
      for (let i = 0; i < this.lasts.length; i++) {
        if (this.lasts[i].type) {
          this.by++;
          break;
        }
      }
      if (this.by === 2) {
        this.videoGo(); // 视频继续播放
      }
    },
    // 根据用户选中的角色改变测试结果：如果用户选中的角色和测试结果最高分相同则改变结果
    setScore(i) {
      // 1男  2女
      if (this.resSex === 1) {
        this.setScoreGM(5);
      }
      if (this.resSex === 2) {
        this.setScoreGM(3);
      }
      // 0碎梦  1血河  2神相  3铁衣  4九灵  5素问  6龙吟
      let maxNum = Math.max.apply(null, this.score);
      // 测试结果中最大值的下标（对应角色）
      let n = this.score.indexOf(maxNum);
      if (i === n) {
        let arr = this.score;
        arr[n] = 0;

        // 找出第二名
        let maxNum1 = Math.max.apply(null, arr);
        let x = arr.indexOf(maxNum1);

        // 互换
        arr[n] = maxNum1;
        arr[x] = maxNum;

        // 去重(有可能测试结果有两个100%)
        let into = [];
        for (let i = 0; i < arr.length; i++) {
          into.includes(arr[i]) ? into.push(arr[i] - 1) : into.push(arr[i]);
        }
        this.scoreFn(into);
      }
    },
    videoGo() {
      setTimeout(() => {
        this.handleBtnClick();
      }, 1000);
    },

    setResult(option) {
      // 第几题this.loopIndex - 1
      // 选了第几题 option
      // 修改全局答案
      this.recordingFn({
        res: this.result[this.loopIndex - 1][option],
        index: this.loopIndex
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.problem {
  @include TBcenter;
  transform: translate(0, -65%);
  @include wh(10.96rem);
  right: 2.2rem;

  img {
    @include wh(100%);
    display: block;
  }
  .topic {
    @include wh(100%);
    position: absolute;
    left: 0;
    top: 0;
  }
  .topicPoster {
    height: 0;
    .poster {
      display: block;
      width: 100%;
    }
  }
  .goBtn {
    @include wh(3.23rem);
    position: absolute;
    bottom: 0;
    left: 4.05rem;
  }
  .goBtnMedia {
    @include wh(2.5rem);
    left: 2.8rem;
  }
  li {
    font-family: "fz";
    font-size: 0.29rem;
    margin-left: 1.8rem;
    text-align: center;
    position: relative;
    color: #2a363a;
    margin-bottom: 0.13rem;
    @media all and (max-width: 990px) {
      font-size: 0.35rem;
    }
    img {
      @include LTput();
      @include wh(100%, 100%);
      display: block;
      z-index: 1;
    }
    span {
      position: relative;
      z-index: 2;
    }
  }
  li.Media {
    font-size: 0.35rem;
  }
  li.active {
    color: #d8ce9a;
  }
}
.problemMedia {
  @include wh(8rem);
  @include LTRBcenter;
  transform: translate(-50%, -50%) rotate(90deg);
  top: 60%;
}
.problem1_5 {
  & > ul {
    opacity: 0;
    transition: opacity 0.5s ease;
  }
  .itemOpacity {
    opacity: 1;
  }
}

.item0 {
  .start {
    @include imgPoster(38.7%);
  }
}
.item1 {
  right: 7.4rem;

  .topic {
    @include wh(10.1rem);
    @media all and (max-width: 990px) {
      @include wh(12rem);
    }
  }
  .topicPoster {
    @include wh(10.1rem);
    @media all and (max-width: 990px) {
      @include wh(12rem);
    }
    .poster {
      @include imgPoster(17.635%);
    }
  }

  .grain {
    @include wh(9.84rem);
    transform: translateY(-30%);
    @media all and (max-width: 990px) {
      @include wh(12rem);
    }
  }
  li {
    @include wh(4.7rem, 0.66rem);
    line-height: 0.66rem;
    @media all and (max-width: 990px) {
      @include wh(5.5rem, 0.8rem);
      line-height: 0.8rem;
    }
    img {
      transform: translateX(-4px);
    }
  }
}
.item1Media {
  right: inherit;
  top: 25%;

  .topic {
    @include wh(10.1rem);
  }
  .topicPoster {
    @include wh(10.1rem);
    .poster {
      @include imgPoster(17.635%);
    }
  }

  .grain {
    @include wh(9.84rem);
    transform: translateY(-30%);
  }
  li {
    @include wh(4.7rem, 0.66rem);
    line-height: 0.66rem;
  }
}
.item2 {
  @include LTRBcenter;
  left: 58%;
  transform: translate(-50%, -70%);
  .topic {
    @include wh(10.64rem);
    @media all and (max-width: 990px) {
      @include wh(12rem);
    }
  }
  .topicMedia {
    @include LRcenter;
    top: 0;
  }
  .topicPoster {
    @include wh(10.64rem);
    @media all and (max-width: 990px) {
      @include wh(12rem);
    }
    .poster {
      @include imgPoster(16.91%);
    }
  }

  .grain {
    // @include wh(8.64rem);
    transform: translateY(-50%);
    // position: absolute;
    // right: -0.5rem;
  }
  li {
    @include wh(6.8rem, 0.7rem);
    line-height: 0.7rem;
    margin: 0.065rem auto;
    @media all and (max-width: 990px) {
      @include wh(7rem, 0.75rem);
      line-height: 0.75rem;
    }
    img {
      transform: translateX(-3px);
    }
  }
}
.item2Media {
  transform: translate(-45%, -65%) rotate(90deg);
  .topic {
    @include wh(10.64rem);
  }
  .topicPoster {
    @include wh(10.64rem);
    .poster {
      @include imgPoster(16.91%);
    }
  }
  li {
    @include wh(6.8rem, 0.7rem);
    line-height: 0.7rem;
    margin: 0.065rem auto;
  }
}
.item3 {
  @include LRcenter;
  top: 0.8rem;

  .topic {
    @include wh(9.91rem);
    @media all and (max-width: 990px) {
      @include wh(11rem);
    }
  }
  .topicPoster {
    @include wh(9.91rem);
    @media all and (max-width: 990px) {
      @include wh(11rem);
    }
    .poster {
      @include imgPoster(16.61%);
    }
  }
  .grain {
    transform: translate(-10%, -80%);
  }
  ul {
    @include wh((5.2rem + 0.3rem) * 2);
    font-size: 0;
    @media all and (max-width: 990px) {
      @include wh((6rem + 0.3rem) * 2);
    }
  }
  li {
    @include wh(5.2rem, 0.65rem);
    line-height: 0.65rem;
    display: inline-block;
    margin-left: 0.3rem;
    margin-bottom: 0.2rem;
    @media all and (max-width: 990px) {
      @include wh(6rem, 0.7rem);
    }
  }
}
.item3Media {
  @include wh(11rem);

  transform: translate(-40%, -50%) rotate(90deg);
  top: 50%;
  .topic {
    @include wh(9.91rem);
  }
  .topicPoster {
    @include wh(9.91rem);
    .poster {
      @include imgPoster(16.61%);
    }
  }
  ul {
    @include wh((5.2rem + 0.3rem) * 2);
    font-size: 0;
  }
  li {
    @include wh(5.2rem, 0.65rem);
    line-height: 0.65rem;
  }
}
.item4 {
  @include LRcenter;
  transform: translateX(-45%);
  top: 2.8rem;

  .topic {
    @include wh(9.56rem);
    @media all and (max-width: 990px) {
      @include wh(13rem);
    }
  }
  .topicPoster {
    @include wh(9.56rem);
    @media all and (max-width: 990px) {
      @include wh(13rem);
    }
    .poster {
      @include imgPoster(23.955%);
    }
  }
  ul {
    transform: translateY(-0.26rem);
    @media all and (max-width: 990px) {
      transform: translateY(0rem);
    }
  }
  li {
    @include wh(5.8rem, 0.69rem);
    line-height: 0.69rem;
    @media all and (max-width: 990px) {
      @include wh(8rem, 0.75);
      line-height: 0.75rem;
    }
  }
  .grain {
    transform: translateY(-100%);
  }
}
.item4Media {
  transform: translate(-50%, -50%) rotate(90deg);
  top: 42%;
  left: 55%;

  .topic {
    @include wh(9.56rem);
  }
  .topicPoster {
    @include wh(9.56rem);
    .poster {
      @include imgPoster(23.955%);
    }
  }

  ul {
    transform: translateY(-0.1rem);
  }
  li {
    @include wh(5.8rem, 0.69rem);
    line-height: 0.69rem;
  }
}
.item5 {
  transform: translateY(0);
  top: 1.9rem;
  right: 2rem;
  @media all and (max-width: 990px) {
    right: 3.5rem;
  }
  ul {
    font-size: 0;
    @include wh((4.5rem + 0.25rem) * 2);
    margin-left: 1.75rem;
  }
  li {
    @include wh(4.2rem, 0.67rem);
    line-height: 0.67rem;
    display: inline-block;
    margin-left: 0.25rem;
    @media all and (max-width: 990px) {
      @include wh(4.5rem, 0.7rem);
      line-height: 0.7rem;
    }
  }
  .topic {
    @include wh(10.4rem);
    @media all and (max-width: 990px) {
      @include wh(12rem);
    }
  }
  .topicPoster {
    @include wh(10.4rem);
    @media all and (max-width: 990px) {
      @include wh(12rem);
    }
    .poster {
      @include imgPoster(15.8685%);
    }
  }
  .grain {
    position: absolute;
    bottom: 0;
    transform: translate(12%, 80%);
    @media all and (max-width: 990px) {
      transform: translate(0, 100%);
    }
  }
}
.item5Media {
  transform: translate(-25%, -50%) rotate(90deg);
  right: inherit;
  top: 35%;

  .topic {
    @include wh(10.4rem);
  }
  .topicPoster {
    @include wh(10.4rem);
    .poster {
      @include imgPoster(15.8685%);
    }
  }

  ul {
    @include wh((4.2rem + 0.25rem) * 2);
    margin-left: 1.1rem;
  }
  li {
    @include wh(4.2rem, 0.67rem);
    line-height: 0.67rem;
  }
}
.last {
  text-align: center;

  .topic {
    @include wh(11.07rem);
    @media all and (max-width: 990px) {
      @include wh(13rem);
    }
  }
  .topicPoster {
    @include wh(11.07rem);
    @media all and (max-width: 990px) {
      @include wh(13rem);
    }
    .poster {
      @include imgPoster(14.4578%);
    }
  }
  h2 {
    font-size: 0.5rem;
    @include fontFamily;
    text-align: center;
    margin-top: 0.15rem;
    @media all and (max-width: 990px) {
      font-size: 0.6rem;
    }
  }
  .sex {
    text-align: center;
    @include wh(2.45rem, 1.4rem);
    display: block;
    margin: 0 auto;
    margin-top: 0.15rem;
    &:after {
      content: "";
      display: block;
      clear: both;
    }
    img {
      width: 0.8rem;
      display: block;
    }
    .sexM {
      float: left;
    }
    .sexG {
      float: right;
    }
  }

  ul {
    margin-top: 0.15rem;
  }

  li {
    display: inline-block;
    @include wh(0.63rem, 2.21rem);
    line-height: 2.5rem;
    margin-left: 0.1rem;
    @media all and (max-width: 990px) {
      @include wh(0.75rem, 2.5rem);
      font-size: 0.4rem;
      line-height: 2.9rem;
    }
    span {
      display: inline-block;
      line-height: 0.3rem;
      @media all and (max-width: 990px) {
        line-height: 0.4rem;
      }
    }
  }
}
.lastMedia {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(90deg);

  .grain {
    transform: translateY(-60%);
  }
  .topic {
    @include wh(11.07rem);
  }
  .topicPoster {
    @include wh(11.07rem);
    .poster {
      @include imgPoster(14.4578%);
    }
  }
  h2 {
    font-size: 0.5rem;
    @include fontFamily;
    text-align: center;
    margin-top: 0.15rem;
  }
  li {
    display: inline-block;
    @include wh(0.63rem, 2.21rem);
    line-height: 2.5rem;
    margin-left: 0.1rem;
    span {
      display: inline-block;
      line-height: 0.3rem;
    }
  }
}
.item6 {
  @include LTRBcenter;
  transform: translate(-50%, -65%);
  @media all and (max-width: 990px) {
    transform: translate(-60%, -65%);
  }
}
.item6Media {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  @include wh(100%, 100%);
  transform: rotate(0);
}
</style>

